<template>
  <section>
    <div>
      <div class="second-image">
        <SeoHero
          :left-image="
            require('~/assets/images/illustrations/commuter-left.png')
          "
          :right-image="
            require('~/assets/images/illustrations/svg/Ebike Commuter city.svg')
          "
          left-position="-180px"
          right-position="100px"
          left-position-desktop="-130px"
          bike-type="commuter"
          @cta="handleClick"
        >
          Cycle Insurance For Your <br />
          Commute And More
        </SeoHero>
      </div>
      <div class="container">
        <Featured />
        <ComprehensiveCover />
        <RideSmartAndSafe />
        <BlogWidget
          title="Some helpful tips for your commute"
          :slugs="[
            '10-top-commuting-tips',
            'how-to-lock-your-bike-the-right-way',
            '6-tips-for-cycling-at-night',
            '10-rules-of-the-highway-code-every-cyclist-should-know',
          ]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Featured from '@/components/homepage/Featured'
import ComprehensiveCover from '@/components/commuter/ComprehensiveCover'
import SeoHero from '@/components/seo/SeoHero'
import RideSmartAndSafe from '@/components/commuter/RideSmartAndSafe'
import BlogWidget from '@/components/blog-widget/BlogWidget'
import { buildSocialMeta, resolveSocialImage } from '@/helpers/social-meta'
import { productOffer } from '@/helpers/product-offer'

// og:image and Product.image both read this, so the two cannot drift apart.
const OG_IMAGE_PATH = '/images/og/commuter-cycle-insurance-1200x630.png'

// The bike this page is about: drives the CTA href and the modal prefill.
const BIKE_TYPE = 'commuter'

export default {
  name: 'CommuterCycleInsurance',
  components: {
    Featured,
    ComprehensiveCover,
    RideSmartAndSafe,
    BlogWidget,
    SeoHero,
  },

  data() {
    return {
      page: {
        title: 'Cycle Insurance For Your Commute (And More) | Pedalsure',
        meta_description:
          'Comprehensive cover for your commute from Pedalsure. We cover your bike and accessories against theft (including at work), accidental damage and loads more.',
      },
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'commuter insurance, road, cycling',
        },
        ...buildSocialMeta({
          title: this.page.title,
          description: this.page.meta_description,
          path: this.$route.path,
          image: OG_IMAGE_PATH,
          type: 'website',
        }).meta,
      ],
      script: [
        {
          innerHTML: `
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Commuter Cycle Insurance",
          "logo": "https://www.pedalsure.com/Pedalsure-Logo_Large.svg",
          "image": ${JSON.stringify([resolveSocialImage(OG_IMAGE_PATH)])},
          "description": "Comprehensive cover for your commute from Pedalsure. We cover your bike and accessories against theft (including at work), accidental damage and loads more.",
           "brand": {
            "@type": "Brand",
            "name": "Pedalsure"
          },
          "offers": ${JSON.stringify(productOffer())}
        }
        `,
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    handleClick() {
      this.resetQuote()
      // Same values the CTA's href carries, so a quote started from the modal
      // is attributed identically to one started by following the link.
      this.$modal.show('quick-quote', {
        bikeType: BIKE_TYPE,
        src: `lp-${BIKE_TYPE}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>

<style lang="scss" scoped>
/* Hero styling now lives in components/seo/SeoHero.vue */
</style>
